module.exports = __webpack_public_path__ + "static/img/device-mupli.7fd0b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/device-mupli.png
// module id = RVBP
// module chunks = 1